import React, { useState } from 'react';
import { useParams, useHistory } from 'react-router-dom';
import classnames from 'classnames';
import { Dropdown, Menu, Button, Modal, message } from 'antd';
import { BellOutlined, DownOutlined, ExclamationCircleOutlined } from '@ant-design/icons';

import { updateRecord } from '../api';
import { QuestionListItem } from '../types';
import { lookStatus, LookStatus } from '../constant';

const { confirm } = Modal;

const checkValues = {
  0: '全部',
  1: '答对',
  2: '答错'
}

interface IProps {
  testInfo: any;
  initList: QuestionListItem[];
  questionList: QuestionListItem[];
  status: LookStatus;
  setQuestionList: (data: QuestionListItem[]) => void;
}

function ProcessInfo({ testInfo, initList, questionList, status, setQuestionList }: IProps) {
  const [currKey, setCurrKey] = useState<'0' | '1' | '2'>('0');
  const history = useHistory();
  const urlParams: { id: string,examType:string } = useParams();
  const userinfo = JSON.parse(localStorage.getItem('userinfo') || JSON.stringify({})) || {};

  function computedTotalGrade(): number {
    let total = 0;
    questionList && questionList.map(ques => {
      ques.questions && ques.questions.map(item => {
        total += item.myGrade;
        return item;
      })
      return ques;
    })
    return Number(total);
  }

  function updateExamRecord() {
    let _questions: any[] = [];
    questionList.map(ques => {
      ques.questions && ques.questions.map(item => {
        const param:any = {
          questionID: item.id,
          questionType: item.questionType,
          isCorrect: item.isCorrect,
          grade: item.myGrade,
        }
        if(Number(urlParams.examType) === 2 ) param.answer=item.answer;
        _questions.push(param)
        return item;
      })
      return ques;
    });
    const params = {
      id: Number(urlParams.id),
      user_id: userinfo.id,
      questions: _questions
    };
    updateRecord(params).then((res: any) => {
      if (res && res.code === 0) {
        message.success("修改成功！");
      } else {
        res && message.error(res.msg || '修改失败！');
      }
    })
  }

  function goBack() {
    history.go(-1);
  }

  function clickMenuItem(item: any) {
    let key = item.key || '0';
    let newData: QuestionListItem[] = [];
    if (key === '0') {
      newData = [...initList];
    }
    if (key === '1') {
      initList.map(ques => {
        let newQuestions = ques.questions && ques.questions.filter(item => item.isCorrect === 1);
        newData.push({
          ...ques,
          questions: newQuestions
        })
        return ques;
      })
    };
    if (key === '2') {
      initList.map(ques => {
        let newQuestions = ques.questions && ques.questions.filter(item => item.isCorrect === 0);
        newData.push({
          ...ques,
          questions: newQuestions
        })
        return ques;
      })
    };
    setQuestionList(newData);
    setCurrKey(item.key || '0');
  }

  function confirmRecord() {
    confirm({
      title: '是否确认提交考试记录?',
      icon: <ExclamationCircleOutlined />,
      zIndex: 10,
      onOk() {
        updateExamRecord();
      },
      onCancel() {
        console.log('Cancel');
      },
    });
  }

  const menu = (
    <Menu selectedKeys={[currKey]} onClick={clickMenuItem}>
      <Menu.Item key="0">全部</Menu.Item>
      <Menu.Item key="1">答对</Menu.Item>
      <Menu.Item key="2">答错</Menu.Item>
    </Menu>
  );

  return (
    <div className="content-right">
      {
        status === lookStatus.see && (
          <>
            <ul className="menu-items">
              <li className="menu-item menu-item-time">
                <div className="item-label">剩余时间</div>
                <div className="item-value">00:59:59</div>
              </li>
              <li className="menu-item menu-item-process">
                <div className="item-label">当前进度</div>
                <div className="item-value">0/0</div>
              </li>
              <li className="menu-item menu-item-fontsize">
                <div className="icon">-</div>
                <span>字号</span>
                <div className="icon">+</div>
              </li>
              <li className="menu-item menu-item-remind">
                <div className="icon"><BellOutlined /></div>
                <div>提醒记录</div>
              </li>
            </ul>
            <div className="btn">
              <Button type="primary">提交试卷</Button>
            </div>
          </>
        )
      }
      {
        [lookStatus.review, lookStatus.view].includes(status) && (
          <>
            <ul className="menu-items">
              {
                lookStatus.review === status && (
                  <li className="menu-item menu-item-name">
                    <div className="item-label">考生姓名</div>
                    <div className="item-value">{testInfo.username}</div>
                  </li>
                )
              }
              <li className={classnames('menu-item menu-item-result', {
                pass: testInfo.isPass === 1
              })}>
                <div className="item-label">考试成绩</div>
                <div className="item-value">{computedTotalGrade().toFixed(1)}</div>
              </li>
              <li className={classnames('menu-item menu-item-status', {
                pass: testInfo.isPass === 1
              })}>
                <div className="item-label">考试状态</div>
                <div className="item-value">{testInfo.isPass === 0 ? '不通过' : '通过'}</div>
              </li>
              <li className="menu-item menu-item-check">
                <div className="item-label">筛选试题</div>
                <div className="item-value">
                  <Dropdown overlay={menu}>
                    <div style={{ cursor: 'pointer' }}>
                      {checkValues[currKey]} <DownOutlined />
                    </div>
                  </Dropdown>
                </div>
              </li>
            </ul>
            <div className="btn">
              {/* {
                lookStatus.review === status && (
                  <div className="act">
                    <div className="disabled">上一人</div>
                    <div>下一人</div>
                  </div>
                )
              } */}
              {lookStatus.review === status && <Button type="primary" onClick={confirmRecord}>提交判卷记录</Button>}
              {lookStatus.view === status && <Button type="primary" onClick={goBack}>返回</Button>}
            </div>
          </>
        )
      }

    </div>
  )
}

export default ProcessInfo;
